import { MsalGuardConfiguration, MsalInterceptorConfiguration, } from '@azure/msal-angular';
import {
    BrowserCacheLocation,
    InteractionType,
    IPublicClientApplication,
    LogLevel,
    PublicClientApplication,
} from '@azure/msal-browser';
import { environment } from '../../../environments/environment';

export function loggerCallback(logLevel: LogLevel, message: string): void {
    if (!environment.production) {
        console.log(`[MSAL ${LogLevel[logLevel]}] ${message}`);
    }
}

export function MSALInstanceFactory(): IPublicClientApplication {
    return new PublicClientApplication({
        auth: {
            clientId: environment.msalConfig.clientId,
            authority: environment.msalConfig.authority,
            redirectUri: globalThis.location.origin,
            postLogoutRedirectUri: globalThis.location.origin,
            knownAuthorities: [environment.msalConfig.knownAuthority],
        },
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage,
        },
        system: {
            loggerOptions: {
                loggerCallback,
                logLevel: LogLevel.Error,
                piiLoggingEnabled: false,
            },
        },
    });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string>>();
    protectedResourceMap.set(
        `${environment.apiUrl}/*`,
        environment.msalConfig.scopes
    );

    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap,
    };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        authRequest: {
            scopes: environment.msalConfig.scopes,
        },
    };
}
